// extracted by mini-css-extract-plugin
export default {"wel":"Header_wel__0ReDC","a":"Header_a__8c5aJ","nav":"Header_nav__XE0tA","rightContainer":"Header_rightContainer__UOPza","link":"Header_link__30vBs","menu":"Header_menu__I2GRn"};